import { graphConfig } from "./authConfig";
import log from '../common/components/Logger'

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export async function callAuthApi() {
    const idToken = localStorage.getItem("idToken");
    
    const headers = new Headers();
    const bearer = `Bearer ${idToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "POST",
        headers: headers
    };

    return fetch(graphConfig.authApiEndpoint, options)
        .then(response => {
            if (!response.ok) {
                const error = new Error(`HTTP error! status: ${response.status}`);
                error.status = response.status;
                throw error;
            }
            return response.json();
        })
        .catch(error => {
            log.error(`Auth API fetch failed: ${error.message}`);
            throw error;
        });
}